import { Accept } from 'react-dropzone';

// Reference: https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Complete_list_of_MIME_types
export const DEFAULT_ACCEPTED_MIME_TYPES: Accept = {
  'image/*': ['.png', '.gif', '.jpeg'],
};
